import { Footer } from '@/components/Footer/Footer';
import StorageAutomation from '@/components/Storage/StorageAutomation';
import StorageConnection from '@/components/Storage/StorageConnection';
import StorageHeading from '@/components/Storage/StorageHeading';
import StorageObjective from '@/components/Storage/StorageObjective';
import StorageStatistics from '@/components/Storage/StorageStatistics';

export default function ForStorage() {
	return (
		<>
			<main>
				<StorageHeading />
				<StorageObjective />
				<StorageAutomation />
				<StorageStatistics />
				<StorageConnection />
			</main>
			<Footer />
		</>
	);
}
